import React from "react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import { Alert } from "flowbite-react";
import { formatDocument } from "../../../utils/utils";
import Protestos from "../../common/query/Protestos";
import ChequesSemFundos from "../../common/query/ChequesSemFundos";

const SPCSerasaPF = ({ data }) => {
  return (
    <>
      {data?.statusRetorno == 1 && (
        <>
          <TitleStripe>III - Dados Cadastrais</TitleStripe>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 text-sm border border-gray-200 rounded-xl overflow-hidden">
            {[
              { label: "Nome completo", value: data?.dadosCadastrais?.nome },
              {
                label: "CPF",
                value: formatDocument(data?.dadosCadastrais?.cpf),
              },
              {
                label: "Data de nascimento",
                value: data?.dadosCadastrais?.dataNascimento,
              },
              { label: "Origem CPF", value: data?.dadosCadastrais?.regiaoCPF },
            ].map((item, index) => (
              <div
                key={index}
                className={`p-4 border-b border-gray-200 ${
                  (index + 1) % 2 === 0 ? "" : "sm:border-r"
                }`}
              >
                <p className="text-gray-500 text-xs mb-1">{item.label}</p>
                {item.isStatus ? (
                  <span
                    className={`font-semibold text-sm px-2 py-0.5 rounded-md text-white inline-block ${
                      item.value?.toUpperCase() === "REGULAR"
                        ? "bg-blue-800"
                        : "bg-red-500"
                    }`}
                  >
                    {item.value || "Indisponível"}
                  </span>
                ) : (
                  <p className="font-medium text-gray-800">
                    {typeof item.value === "string"
                      ? item.value?.trim() || "Indisponível"
                      : item.value || "Indisponível"}
                  </p>
                )}
              </div>
            ))}
          </div>
          <div>
            <TitleStripe className="mb-5">
              II - Pendências Financeiras
            </TitleStripe>

            {data?.pendenciasSerasa?.length > 0 ? (
              <div className="flex gap-2 items-start">
                <div className="flex-1">
                  <PendenciasFinanceiras
                    quantidadeTotal={
                      data?.resumoConsulta?.serasa?.quantidadeTotal
                    }
                    valorTotal={data?.resumoConsulta?.serasa?.valorTotal}
                    pendenciasFinanceiras={data?.pendenciasSerasa}
                  />
                </div>
              </div>
            ) : (
              <NoOcurrence />
            )}
          </div>

          <div>
            <TitleStripe className="mb-5">
              III - Restrições Financeiras
            </TitleStripe>

            {data?.pendenciasSpc?.length > 0 ? (
              <div className="flex gap-2 items-start">
                <div className="flex-1">
                  <PendenciasFinanceiras
                    quantidadeTotal={data?.resumoConsulta?.spc?.quantidadeTotal}
                    valorTotal={data?.resumoConsulta?.serasa?.valorTotal}
                    pendenciasFinanceiras={data?.pendenciasSpc}
                  />
                </div>
              </div>
            ) : (
              <NoOcurrence />
            )}
          </div>

          <div>
            <TitleStripe className="mb-5">III - Protestos</TitleStripe>

            {data?.protestos?.length > 0 ? (
              <div className="flex gap-2 items-start">
                <div className="flex-1">
                  <Protestos
                    quantidadeTotal={
                      data?.resumoConsulta?.protestos?.quantidadeTotal
                    }
                    valorTotal={data?.resumoConsulta?.protestos?.valorTotal}
                    protestos={data?.protestos}
                  />
                </div>
              </div>
            ) : (
              <NoOcurrence />
            )}
          </div>

          <div>
            <TitleStripe className="mb-5">III - Cheques sem Fundo</TitleStripe>

            {data?.chequesSemFundo?.length > 0 ? (
              <div className="flex gap-2 items-start">
                <div className="flex-1">
                  <ChequesSemFundos
                    quantidadeTotal={
                      data?.resumoConsulta?.chequesSemFundo?.quantidadeTotal
                    }
                    valorTotal={
                      data?.resumoConsulta?.chequesSemFundo?.valorTotal
                    }
                    chequesSemFundos={data?.chequesSemFundo}
                  />
                </div>
              </div>
            ) : (
              <NoOcurrence />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default SPCSerasaPF;
